import { useState, useEffect } from 'react'
import Card from '../components/Card'

const units = {
  'mm²': { name: 'Square Millimeter', factor: 0.000001 },
  'cm²': { name: 'Square Centimeter', factor: 0.0001 },
  'm²': { name: 'Square Meter', factor: 1 },
  'km²': { name: 'Square Kilometer', factor: 1000000 },
  'in²': { name: 'Square Inch', factor: 0.00064516 },
  'ft²': { name: 'Square Foot', factor: 0.092903 },
  'yd²': { name: 'Square Yard', factor: 0.836127 },
  'mi²': { name: 'Square Mile', factor: 2589988.11 },
  acre: { name: 'Acre', factor: 4046.86 },
  hectare: { name: 'Hectare', factor: 10000 },
}

export default function AreaConverter() {
  const [fromUnit, setFromUnit] = useState('m²')
  const [toUnit, setToUnit] = useState('ft²')
  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  const convert = () => {
    if (!fromValue || isNaN(fromValue)) {
      setToValue('')
      return
    }

    const value = parseFloat(fromValue)
    const fromFactor = units[fromUnit].factor
    const toFactor = units[toUnit].factor

    const squareMeters = value * fromFactor
    const result = squareMeters / toFactor

    setToValue(result.toFixed(6).replace(/\.?0+$/, ''))
  }

  useEffect(() => {
    convert()
  }, [fromUnit, toUnit, fromValue])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">From:</label>
              <select
                value={fromUnit}
                onChange={(e) => setFromUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="number"
                value={fromValue}
                onChange={(e) => setFromValue(e.target.value)}
                className="input w-full mt-3"
                placeholder="Enter value"
                step="any"
              />
            </div>
            <div>
              <label className="label">To:</label>
              <select
                value={toUnit}
                onChange={(e) => setToUnit(e.target.value)}
                className="input w-full"
              >
                {Object.entries(units).map(([key, unit]) => (
                  <option key={key} value={key}>{unit.name}</option>
                ))}
              </select>
              <input
                type="text"
                value={toValue}
                readOnly
                className="input w-full mt-3 bg-gray-50"
                placeholder="Result"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

